module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ShareAppView.js"));
	}, "ShareAppView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ShareAppView!./src/pages/DownLoad/ShareApp/ShareAppView.js
// module id = 1776
// module chunks = 418